import { LinearProgress } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import dayjs from 'dayjs';
import HelloSign from 'hellosign-embedded';
import React, { useContext, useEffect, useState } from 'react';
//redux
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { GetSpecificClient } from '../../api/Clients/getAllVisibleClient.api';
import { GetDocumentByInfoAPS } from '../../api/Clients/getClientDocumentForm.api';
import * as firebaseDocumentCalls from '../../api/Clients/getFirebaseDocumentInfo.api';
import sendDocumentToSalesAgent from '../../api/Documents/sendDocumentToSalesAgent.api';
import * as CLIENT_ID from '../../constants/helloSignClientId';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';
import * as ORIGINAL_HREF from '../../constants/originalHref';
import * as PROJECT_CODE from '../../constants/projectCode';
import { FirebaseContext } from '../../context/firebase';
import Modal from '../layout/modal/Modal';
import './Doc.css';
import { SaveOrUpdateDocument } from './SaveAndLoadDocument';
import './StepBar.css';

function StepBar({
	totalCost,
	setTotalCost,
	lotList,
	setElevationList,
	elevationList,
	setExteriorImgLink,
	setPricingDetails,
	setElevationPriceSum,
	exteriorImage,
	setExteriorImage,
	navigation,
	buildingPriceSum,
	setBuildingPriceSum,
	elevationPriceSum,
	lotPriceSum,
	setLotPriceSum,
	elevationPrice,
	elevationId,
	lotPrice,
	pricingDetails,
	totalUpgradePrice,
	upgradeTotal,
	irrevocableDate,
	closingDate,
	individualDetails,
	corporationDetails,
	lawyerDetails,
	coBrokerDetails,
	mortgageDetails,
	expanded,
	setExpanded,
	setIsCompleted,
	isCompleted,
	setDisable,
	disable,
	loading,
	setLoading,
	upgradeTotalPrice,
	displayFinal,
	setDisplayFinal,
	setElevationId,
	clientZipCode,
	setClientZipCode,
	floorplan,
	totalMainFloor,
	setElevationTab,
	elevationTab,
	lotActive,
	setLotActive,
	individualSecondPurchaserDetails,
	optionSum,
	premiumDescription,
	userType,
	coBrokersSalesAgent,
	optionSelected,
	coolingPeriodExtensionDay,
	user,
	floorPlanChecked,
	setFloorPlanChecked,
	firstInstallmentDate,
	setFirstInstallmentDate,
	firstInstallmentCost,
	setFirstInstallmentCost,
	secondInstallmentDate,
	setSecondInstallmentDate,
	secondInstallmentCost,
	setSecondInstallmentCost,
	thirdInstallmentDate,
	setThirdInstallmentDate,
	thirdInstallmentCost,
	setThirdInstallmentCost,
	forthInstallmentDate,
	setForthInstallmentDate,
	forthInstallmentCost,
	setForthInstallmentCost,
	fifthInstallmentDate,
	setFifthInstallmentDate,
	fifthInstallmentCost,
	setFifthInstallmentCost,
	sixthInstallmentDate,
	setSixthInstallmentDate,
	sixthInstallmentCost,
	setSixthInstallmentCost,
	navigationIndex,
	setNavigationIndex,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [allInfoCombined] = useState({});
	const [lotOnNext, setLotOnNext] = useState();
	const [show, setShow] = useState(false);
	const converter = require('number-to-words');
	const history = useHistory();

	useEffect(() => {
		console.log('This is the lotlist in the useefect', lotList);
	}, [lotList]);

	useEffect(() => {
		console.log('individualDetails: ' + JSON.stringify(individualDetails));
		console.log(
			'coBrokersSalesAgentcoBrokersSalesAgent: ',
			coBrokersSalesAgent
		);
		console.log(
			'individualSecondPurchaserDetails: ' +
				JSON.stringify(individualSecondPurchaserDetails)
		);
	}, []);

	useEffect(() => {
		console.log('totalMainFloortotalMainFloor', totalMainFloor);
	}, [totalMainFloor]);
	useEffect(() => {
		setTotalCost(
			lotPrice + elevationPrice + totalUpgrades + totalMainFloor
		);
	}, [lotPrice, elevationPrice, totalMainFloor, upgradeTotalPrice]);

	const totalUpgrades =
		upgradeTotalPrice.cabinetry +
		upgradeTotalPrice.countertops +
		upgradeTotalPrice.doorstrim +
		upgradeTotalPrice.flooring +
		upgradeTotalPrice.lighting +
		upgradeTotalPrice.plumbing;

	const client = new HelloSign();

	if (ALL_DOCUMENTS.allDocumentTypeInfo.hasGottenInfo === false) {
		firebaseDocumentCalls.GetFirebaseDocumentInformation();
	}

	const handleDocument = () => {
		setShow(false);
		setLoading(true);
		const getDoc = firebase
			.functions()
			.httpsCallable('HelloSignUnclaimedDraft');
		var currentUserId = firebase.auth().currentUser.uid;
		var currentUserName = firebase.auth().currentUser.displayName;
		var currentUserPhone = firebase.auth().currentUser.phoneNumber;
		var buildingCost = elevationList[0]?.buildingPrice;
		var totalCostTemp = numberWithCommas(
			elevationPrice + lotPrice + totalUpgrades + totalMainFloor
		);
		//upgradeTotal;
		var clientEmail = location.state.clientEmail;
		var salesAgentId = location.state.salesAgentId;

		allInfoCombined['clientEmail'] = clientEmail;
		allInfoCombined['buyerFirstName'] = individualDetails?.firstName;
		allInfoCombined['buyerLastName'] = individualDetails?.lastName;
		allInfoCombined['buildingLotNumber'] = pricingDetails[0]?.id;
		allInfoCombined['buildingModelName'] = elevationList[0]?.buildingName;
		allInfoCombined['buildingElevation'] = elevationId;
		allInfoCombined['buildingPrice'] =
			elevationPrice + lotPrice + totalMainFloor;
		allInfoCombined['buildingPriceWord'] = converter.toWords(
			elevationPrice + lotPrice + totalMainFloor
		);
		allInfoCombined['irrevocableDay'] =
			dayjs(irrevocableDate).format('DD MMM YYYY');
		allInfoCombined['closingDay'] =
			dayjs(closingDate).format('DD MMM YYYY');
		allInfoCombined['lawyerName'] = lawyerDetails?.lawyerName;
		allInfoCombined['lawyerAddress'] = lawyerDetails?.address;
		allInfoCombined['lawyerEmail'] = lawyerDetails?.email;
		allInfoCombined['lawyerPhoneNumber'] = lawyerDetails?.phoneNumber;
		allInfoCombined['sellerFullName'] = currentUserName;
		allInfoCombined['sellerPhoneNumber'] = currentUserPhone;
		allInfoCombined['totalCost'] = totalCostTemp;

		allInfoCombined['clientAddress'] = individualDetails?.address;
		allInfoCombined['clientPhone'] = individualDetails?.phoneNumber;

		allInfoCombined['clientDOB'] = new dayjs(individualDetails?.dob).format(
			'DD/MM/YYYY'
		);
		allInfoCombined['postalCode'] = clientZipCode;
		allInfoCombined['optionSelected'] = optionSelected;

		const displayHelloDoc = (signUrl) => {
			console.log('signurl: ' + signUrl);
			client.open(signUrl, {
				skipDomainVerification: true,
				clientId: CLIENT_ID.clientId,
			});
		};

		if (userType === 'superadmin' || userType === 'admin') {
			GetSpecificClient(clientEmail, salesAgentId).then((returned) => {
				console.log('Get specific client', returned);

				var thisClient = returned;
				var currentUserEmail = firebase.auth().currentUser.email;
				var buildingPrice = totalCost;

				var currentPriceWord = converter.toWords(totalCost);

				console.log('GetSpecificClient', thisClient);

				console.log(
					'Building name',
					elevationList[0]?.buildingName +
						' ' +
						ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo
							.buildingTemplateId[elevationList[0]?.buildingName]
				);

				var listOptionsString = [];
				var selectKeys = [];
				if (
					floorPlanChecked !== undefined &&
					floorPlanChecked !== null
				) {
					var optionSelectedKeys = Object.keys(floorPlanChecked);

					if (
						optionSelectedKeys !== undefined &&
						optionSelectedKeys !== undefined
					) {
						optionSelectedKeys.forEach((optionSel) => {
							listOptionsString.push(
								floorPlanChecked[optionSel].name
							);
						});
						selectKeys = optionSelectedKeys;
					}
				}

				console.log(
					'Get document by info aps in this client',
					thisClient
				);

				GetDocumentByInfoAPS(
					thisClient,
					ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo,
					ORIGINAL_HREF.originalHREF['access_token'],
					currentUserEmail,
					currentPriceWord,
					buildingPrice,
					elevationId,
					clientZipCode,
					individualDetails?.address
						? individualDetails.address
						: corporationDetails?.businessAddress,
					elevationList[0]?.buildingName,
					individualSecondPurchaserDetails,
					selectKeys,
					setLoading,
					location.state.clientCreatorId,
					individualDetails,
					corporationDetails,
					firstInstallmentCost,
					secondInstallmentCost,
					thirdInstallmentCost,
					forthInstallmentCost,
					fifthInstallmentCost,
					sixthInstallmentCost,
					elevationList[0]?.buildingName
				);
			});
		}
		if (userType !== 'cobroker' && userType !== 'superadmin') {
			GetSpecificClient(clientEmail).then((returned) => {
				var thisClient = returned;
				var currentUserEmail = firebase.auth().currentUser.email;
				var buildingPrice = totalCost;

				var currentPriceWord = converter.toWords(totalCost);

				console.log('GetSpecificClient', thisClient);

				console.log(
					'Building name + ' +
						elevationList[0]?.buildingName +
						' ' +
						ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo
							.buildingTemplateId[elevationList[0]?.buildingName]
				);

				var listOptionsString = [];
				var selectKeys = [];
				if (
					floorPlanChecked !== undefined &&
					floorPlanChecked !== null
				) {
					var optionSelectedKeys = Object.keys(floorPlanChecked);

					if (
						optionSelectedKeys !== undefined &&
						optionSelectedKeys !== undefined
					) {
						optionSelectedKeys.forEach((optionSel) => {
							listOptionsString.push(
								floorPlanChecked[optionSel].name
							);
						});
						selectKeys = optionSelectedKeys;
					}
				}

				GetDocumentByInfoAPS(
					thisClient,
					ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo,
					ORIGINAL_HREF.originalHREF['access_token'],
					currentUserEmail,
					currentPriceWord,
					buildingPrice,
					elevationId,
					clientZipCode,
					individualDetails?.address
						? individualDetails.address
						: corporationDetails?.businessAddress,
					elevationList[0]?.buildingName,
					individualSecondPurchaserDetails,
					selectKeys,
					setLoading,
					'',
					individualDetails,
					corporationDetails,
					firstInstallmentCost,
					secondInstallmentCost,
					thirdInstallmentCost,
					forthInstallmentCost,
					fifthInstallmentCost,
					sixthInstallmentCost
				);
			});
		} else if (userType === 'cobroker') {
			setLoading(false);
			var userUid = user.uid;
			sendDocumentToSalesAgent(firebase, clientEmail, userUid);

			history.push({
				pathname: '/clients',
			});
		}
	};

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
		console.log('This is the panel', panel);
		setNavigationIndex(panel);
		navigation.go(panel);
	};

	const Accordion = withStyles({
		root: {
			// border: '1px solid rgba(0, 0, 0, .125)',
			marginBottom: '10px',
			boxShadow: 'none',
			'&:not(:last-child)': {
				borderBottom: 0,
			},
			'&:before': {
				display: 'none',
			},
			'&$expanded': {
				margin: 'auto',
			},
		},
		expanded: {},
	})(MuiAccordion);

	const AccordionSummary = withStyles({
		root: {
			// backgroundColor: 'rgba(0, 0, 0, .03)',
			backgroundColor: 'transparent',
			// borderBottom: '1px solid rgba(0, 0, 0, .125)',
			marginBottom: -1,
			minHeight: 56,
			color: '#555555',
			fontSize: 18,
			'&:hover': {
				backgroundColor: '#e8e8e8',
				borderRadius: 8,
			},
			'&$expanded': {
				minHeight: 56,
				color: '#2662F0',
				backgroundColor: '#e8e8e8',
				borderRadius: 8,
			},
			'&disabled': {
				opacity: '1',
			},
			position: 'relative',
		},
		content: {
			'&$expanded': {
				margin: '12px 0',
			},
		},
		expanded: {},
	})(MuiAccordionSummary);

	const useStyles = makeStyles({
		cardTitle: {
			fontSize: '18px',
			fontWeight: 'bold',
			'&$expanded': {
				color: 'blue',
			},
		},

		caret: {
			marginBottom: '-4px',
		},
	});

	const styles = useStyles();

	const location = useLocation();

	const AccordionDetails = withStyles((theme) => ({
		root: {
			padding: theme.spacing(2),
			display: 'flex',
			flexDirection: 'column',
		},
	}))(MuiAccordionDetails);
	function numberWithCommas(x) {
		return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	function setLotToPending(lotId) {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
			.child(lotId)
			.child('available')
			.set('pending');
	}

	const elevationHandler = (e) => {
		var lotName = e.currentTarget.dataset.lotname;
		var lotSelected = e.currentTarget.dataset.lotnumber;
		var lotSqft = e.currentTarget.dataset.lotsqft;
		var lotPrice = e.currentTarget.dataset.lotprice;
		var buildingArr = [];
		var buildingDetails;
		setDisable({ ...disable, lots: false });

		console.log('lotSelected: ' + lotSelected);

		setLotActive({
			lotName: lotName,
			lotSelected: lotSelected,
			lotSqft: lotSqft,
			lotPrice: lotPrice,
		});

		setLotOnNext(lotSelected);

		firebase.auth().onAuthStateChanged(function (user) {
			function capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			}

			if (user) {
				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/buildingInfo/'
					)
					.orderByKey()
					.equalTo(lotName)
					.once('value', (snapshot) => {
						console.log('test2 : ' + snapshot);
						var priceBreakdownArr = [];
						var elevationPriceList = [];
						snapshot.forEach((elevationDetail) => {
							console.log('foreach : ', elevationDetail);
							var priceRef = elevationDetail.child('priceList');
							var buildingName = elevationDetail.key;
							var buildingPrice =
								elevationDetail.val().buildingPrice;
							var buildingSqft = elevationDetail.val().sqft;

							priceRef.forEach((priceDetail) => {
								var priceBreakdown = {
									buildingName: buildingName,
									buildingPrice: buildingPrice,
									elevationId: priceDetail.val().id,
									elevationPrice: priceDetail.val().price,
									sqft: buildingSqft,
								};

								elevationPriceList.push(
									priceBreakdown.elevationPrice
								);

								priceBreakdownArr.push(priceBreakdown);

								console.log(
									'preiceBreakdown: ' +
										JSON.stringify(priceBreakdownArr)
								);
							});
						});

						var sum = elevationPriceList.reduce(function (a, b) {
							return a + b;
						}, 0);

						setElevationPriceSum(sum);

						console.log('elevationList: ' + priceBreakdownArr);

						// RESULT
						// 0: {buildingName: "nova", elevationId: "a", elevationPrice: 0}
						// 1: {buildingName: "nova", elevationId: "b", elevationPrice: 450000}
						// 2: {buildingName: "nova", elevationId: "c", elevationPrice: 500000}
						setElevationList(priceBreakdownArr);
					});

				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotSelected +
							'/buildings/'
					)
					.once('value', (snapshot) => {
						console.log(snapshot.val());
						snapshot.forEach((snap) => {
							// console.log(snap.val()); //building name

							snap.forEach((building) => {
								buildingDetails = {
									id: lotSelected,
									name: capitalizeFirstLetter(building.key),
									price: building.val().priceList,
									sqft: building.val().sqft,
									buildingPrice: building.val().buildingPrice,
								};

								buildingArr.push(buildingDetails);
							});
						});
						console.log(
							'buildingArr ' + JSON.stringify(buildingArr)
						);
						setPricingDetails(buildingArr);
					});
			}
		});
	};

	const dataForDocument = () => {
		const isCompletedData = isCompleted;
		const disableData = disable;
		const expandedData = expanded;
		const lotListData = lotList ? lotList : '';
		const lotActiveData = lotActive ? lotActive : '';
		const elevationListData = elevationList ? elevationList : '';
		const pricingDetailsData = pricingDetails ? pricingDetails : '';
		const displayFinalData = displayFinal ? displayFinal : '';
		const elevationPriceSumData = elevationPriceSum
			? elevationPriceSum
			: '';
		const buildingPriceSumData = buildingPriceSum ? buildingPriceSum : '';
		const lotPriceSumData = lotPriceSum ? lotPriceSum : '';
		const elevationPriceData = elevationPrice ? elevationPrice : '';
		const elevationIdData = elevationId ? elevationId : '';
		const lotPriceData = lotPrice ? lotPrice : 0;
		const totalUpgradePriceData = totalUpgradePrice
			? totalUpgradePrice
			: '';
		const closingDateData = closingDate ? closingDate : '';
		const individualDetailsData = individualDetails
			? individualDetails
			: '';
		const individualSecondPurchaserDetailsData =
			individualSecondPurchaserDetails
				? individualSecondPurchaserDetails
				: '';
		const corporationDetailsData = corporationDetails
			? corporationDetails
			: '';
		const lawyerDetailsData = lawyerDetails ? lawyerDetails : '';
		const coBrokerDetailsData = coBrokerDetails ? coBrokerDetails : '';
		const mortgageDetailsData = mortgageDetails ? mortgageDetails : '';
		const clientZipCodeData = clientZipCode ? clientZipCode : '';
		const totalCostData = totalCost ? totalCost : '';
		const coolingPeriodExtensionDayData = coolingPeriodExtensionDay
			? coolingPeriodExtensionDay
			: '';
		const floorplanCheckedData = floorPlanChecked ? floorPlanChecked : '';
		const totalMainFloorData = totalMainFloor ? totalMainFloor : '';

		const firstInstallmentDateData = firstInstallmentDate
			? firstInstallmentDate
			: '';
		const secondInstallmentDateData = secondInstallmentDate
			? secondInstallmentDate
			: '';
		const thirdInstallmentDateData = thirdInstallmentDate
			? thirdInstallmentDate
			: '';
		const forthInstallmentDateData = forthInstallmentDate
			? forthInstallmentDate
			: '';
		const fifthInstallmentDateData = fifthInstallmentDate
			? fifthInstallmentDate
			: '';
		const sixthInstallmentDateData = sixthInstallmentDate
			? sixthInstallmentDate
			: '';

		const firstInstallmentCostData = firstInstallmentCost
			? firstInstallmentCost
			: '';
		const secondInstallmentCostData = secondInstallmentCost
			? secondInstallmentCost
			: '';
		const thirdInstallmentCostData = thirdInstallmentCost
			? thirdInstallmentCost
			: '';
		const forthInstallmentCostData = forthInstallmentCost
			? forthInstallmentCost
			: '';
		const fifthInstallmentCostData = fifthInstallmentCost
			? fifthInstallmentCost
			: '';
		const sixthInstallmentCostData = sixthInstallmentCost
			? sixthInstallmentCost
			: '';

		const navigationIndexData = navigationIndex ? navigationIndex : '';

		console.log('navigationIndexData', navigationIndexData);

		var floorplanCheckedDataKeys = Object.keys(floorplanCheckedData);
		var floorplanCheckedNamesArr = [];

		floorplanCheckedDataKeys.forEach((key) => {
			var name = floorplanCheckedData[key]['name'];
			floorplanCheckedNamesArr.push(name);
		});

		var documentJson = {
			document: {
				isCompleted: isCompletedData,
				disable: disableData,
				expanded: expandedData,
				lotList: lotListData,
				lotActive: lotActiveData,
				elevationList: elevationListData,
				pricingDetails: pricingDetailsData,
				displayFinal: displayFinalData,
				elevationPriceSum: elevationPriceSumData,
				buildingPriceSum: buildingPriceSumData,
				lotPriceSum: lotPriceSumData,
				// elevationPrice: elevationPriceData,
				elevationId: elevationIdData,
				lotPrice: lotPriceData,
				totalUpgradePrice: totalUpgradePriceData,
				closingDate: closingDateData,
				individualDetails: individualDetailsData,
				individualSecondPurchaserDetails:
					individualSecondPurchaserDetailsData,
				corporationDetails: corporationDetailsData,
				lawyerDetails: lawyerDetailsData,
				coBrokerDetails: coBrokerDetailsData,
				mortgageDetails: mortgageDetailsData,
				clientZipCode: clientZipCodeData,
				totalCost: totalCostData,
				coolingPeriodExtensionDay: coolingPeriodExtensionDayData,
				totalMainFloor: totalMainFloorData,
				floorplanChecked: floorplanCheckedData,
				optionsSelected: floorplanCheckedNamesArr,
				firstInstallmentDate: firstInstallmentDateData,
				secondInstallmentDate: secondInstallmentDateData,
				thirdInstallmentDate: thirdInstallmentDateData,
				forthInstallmentDate: forthInstallmentDateData,
				fifthInstallmentDate: fifthInstallmentDateData,
				sixthInstallmentDate: sixthInstallmentDateData,
				firstInstallmentCost: firstInstallmentCostData,
				secondInstallmentCost: secondInstallmentCostData,
				thirdInstallmentCost: thirdInstallmentCostData,
				forthInstallmentCost: forthInstallmentCostData,
				fifthInstallmentCost: fifthInstallmentCostData,
				sixthInstallmentCost: sixthInstallmentCostData,
				navigationIndex: navigationIndexData,
			},
		};

		SaveOrUpdateDocument(
			firebase,
			documentJson,
			location.state.clientEmail,
			coBrokersSalesAgent?.ALL_DOCUMENTS,
			location.state.clientCreatorId
		);
	};

	const handleNext = () => {
		setExpanded(expanded + 1);
		navigation.next();
		setNavigationIndex(expanded + 1);
	};
	const handleBack = () => {
		setExpanded(expanded - 1);
		navigation.previous();
	};
	const handleLotsNext = () => {
		setIsCompleted({ ...isCompleted, lots: true });
		if (elevationId === undefined) {
			setElevationId('A');
		}

		setLotToPending(lotOnNext);

		setDisplayFinal({ ...displayFinal, lots: true });

		setTimeout(() => {
			dataForDocument();
		}, 500);
	};
	const handleModelHomesNext = () => {
		setIsCompleted({ ...isCompleted, modelhomes: true });
		if (elevationId === undefined) {
			setElevationId('A');
		}
		setDisplayFinal({ ...displayFinal, modelhomes: true });

		setTimeout(() => {
			dataForDocument();
		}, 500);
	};
	const handlePricingNext = () => {
		setIsCompleted({ ...isCompleted, pricing: true });
		setDisable({ ...disable, pricing: false });
		setDisplayFinal({ ...displayFinal, pricing: true });

		setTimeout(() => {
			dataForDocument();
		}, 500);
	};

	const handleDatesNext = () => {
		setIsCompleted({ ...isCompleted, dates: true });
		setDisplayFinal({ ...displayFinal, dates: true });
		setExpanded(expanded + 1);

		setTimeout(() => {
			dataForDocument();
		}, 500);
	};

	const handleClientNext = () => {
		setIsCompleted({ ...isCompleted, client: true });
		setDisplayFinal({ ...displayFinal, client: true });

		setTimeout(() => {
			dataForDocument();
		}, 500);
	};
	const handleLawyerNext = () => {
		setIsCompleted({ ...isCompleted, lawyer: true });
		setDisable({ ...disable, lawyer: false });
		setDisplayFinal({ ...displayFinal, lawyer: true });

		setTimeout(() => {
			dataForDocument();
		}, 500);
	};
	const handleCoBrokerNext = () => {
		setIsCompleted({ ...isCompleted, coBroker: true });
		setDisable({ ...disable, coBroker: false });
		setDisplayFinal({ ...displayFinal, coBroker: true });
		setExpanded(expanded + 1);

		setTimeout(() => {
			dataForDocument();
		}, 500);
	};

	const handleFinanceBtn = () => {
		setShow(true);
		setDisable({ ...disable, finances: false });
		setDisplayFinal({ ...displayFinal, finance: true });
		setTimeout(() => {
			dataForDocument();
		}, 500);
	};

	// Progress Bar
	// PROGRESS BAR -------
	var MIN = 0;

	const normaliseElevationPrice = (value) => ((value - MIN) * 100) / 0;

	const normaliseTotalOptions = (value) =>
		((value - MIN) * 100) / (optionSum - MIN);

	const normaliseLotPrice = (value) => ((value - MIN) * 100) / 0;

	const normaliseTotalPrice = (value) => ((value - MIN) * 100) / 0;

	const ElevationProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#F17105',
		},
	}))(LinearProgress);
	const OptionProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#10ff00',
		},
	}))(LinearProgress);

	const LotProgress = withStyles((theme) => ({
		root: {
			height: 7,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#6665DD',
		},
	}))(LinearProgress);

	const TotalProgress = withStyles((theme) => ({
		root: {
			height: 8,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor:
				theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundColor: '#0496FF',
		},
	}))(LinearProgress);

	const closeModalHandler = () => setShow(false);

	const handleEdit = () => setShow(false);

	useEffect(() => {
		//console.log('This is the lot list: ' + JSON.stringify(lotList));
	}, [lotList]);

	return (
		<div>
			{/* Lots */}
			<Accordion
				square
				expanded={expanded === 0}
				onChange={handleChange(0)}
			>
				<AccordionSummary
					aria-controls='modelhomes-content'
					id='modelhomes-header'
					disabled={disable.lots}
				>
					{console.log('LOSTLIST: ' + JSON.stringify(lotList))}
					<Typography
						className={styles.cardTitle}
						id={isCompleted.lots === true ? 'isCompleted' : null}
					>
						<StopRoundedIcon className={styles.caret} />
						Lots and Model
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button
							className='back_btn'
							disabled
							onClick={handleBack}
						>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleLotsNext();
							}}
							disabled={disable.lots}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{lotList === undefined || lotList === '' ? (
							<div className='empty_state_handler'>
								Please choose a lot in the site plan.
							</div>
						) : (
							lotList?.map((lot) => (
								<>
									{console.log('lot mapp', lot.name)}
									<div
										className={`${
											lotActive?.lotName === lot.name
												? `lot_single_card building_active`
												: `lot_single_card`
										} ${
											lot.soldout === true
												? `card_disabled`
												: ``
										}`}
										key={lot.name}
										data-lotname={lot.name}
										data-lotnumber={lot.buildingLot}
										data-lotsqft={lot.sqft}
										data-lotprice={lot.buildingPrice}
										onClick={(e) => elevationHandler(e)}
									>
										<p className='lot_single_title'>
											{lot.name} (Lot {lot.buildingLot})
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon
													className={`${
														lot.soldout === true
															? `soldout`
															: `available`
													}`}
												/>
											</span>
											{lot.sqft} SQ FT {'  '}/ {'  '}$
											{numberWithCommas(
												lot.buildingPrice
											)}
										</small>
										{lot.soldout === true ? null : (
											<CheckIcon
												className={`${
													lotActive?.lotName ===
													lot.name
														? `checkmark checkmark_active`
														: `checkmark`
												}`}
											/>
										)}
									</div>
								</>
							))
						)}
						{lotList && (
							<div className='lot_modelhomes_manual'>
								<div className='lot_available'>
									<p>
										<span>
											<RadioButtonUncheckedIcon />
										</span>
										AVAILABLE
									</p>
								</div>
								<div className='lot_sold_out'>
									<p>
										<span>
											<RadioButtonUncheckedIcon />
										</span>
										SOLD OUT
									</p>
								</div>
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					displayFinal.lots === true && expanded !== 0
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='lot_modelhomes_container'>
					<div className='lot_single_card'>
						<p className='lot_single_title'>
							{lotActive?.lotName} (
							{'Lot ' + lotActive?.lotSelected})
						</p>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='available' />
							</span>
							{lotActive?.lotSqft + ' SQFT'}
							{'  '}/ {'  '}${' '}
							{numberWithCommas(lotActive?.lotPrice)}
						</small>
						<CheckIcon className='checkmark checkmark_active' />
					</div>
				</div>
			</div>

			{/* Model Homes */}
			<Accordion
				square
				expanded={expanded === 1}
				onChange={handleChange(1)}
			>
				<AccordionSummary
					aria-controls='modelhomes-content'
					id='modelhomes-header'
					disabled={disable.modelhomes}
				>
					<Typography
						className={styles.cardTitle}
						id={
							isCompleted.modelhomes === true
								? 'isCompleted'
								: null
						}
					>
						<StopRoundedIcon className={styles.caret} />
						Elevation & Options
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleModelHomesNext();
							}}
							disabled={disable.modelhomes}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{elevationId === undefined || elevationId === '' ? (
							<div className='empty_state_handler'>
								Please choose an elevation.
							</div>
						) : (
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{lotActive?.lotName}{' '}
									{elevationId && elevationId}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									Elevation{' '}
									{elevationId !== undefined ||
									elevationId !== ''
										? 'Added'
										: elevationId}{' '}
								</small>

								<CheckIcon className='checkmark checkmark_active' />
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>
			<div
				className={
					displayFinal.modelhomes === true && expanded !== 1
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='lot_modelhomes_container'>
					<div className='lot_single_card'>
						<p className='lot_single_title'>
							{elevationList[0]?.buildingName}{' '}
							{elevationId && elevationId}
						</p>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='available' />
							</span>
							Elevation{' '}
							{elevationId !== undefined || elevationId !== ''
								? 'Added'
								: elevationId}{' '}
							{'  '}
						</small>

						<CheckIcon className='checkmark checkmark_active' />
					</div>
				</div>
			</div>

			{/* Pricing */}
			<Accordion
				square
				expanded={expanded === 2}
				onChange={handleChange(2)}
			>
				<AccordionSummary
					aria-controls='pricing-content'
					id='pricing-header'
					disabled={disable.pricing}
				>
					<Typography
						className={styles.cardTitle}
						id={isCompleted.pricing === true ? 'isCompleted' : null}
					>
						<StopRoundedIcon className={styles.caret} /> Pricing
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handlePricingNext();
							}}
						>
							Next
						</button>
					</div>
					<div className='stepbar_pricing_container'>
						<div className='elevation_progress'>
							<div className={styles.progressBar}>
								<ElevationProgress
									variant='determinate'
									value={normaliseElevationPrice(
										elevationPrice
									)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										$
										{elevationPrice
											? numberWithCommas(
													elevationPrice.toFixed(2)
											  )
											: 0}
									</div>
									<div className='price_legend'>
										{lotActive?.lotName}{' '}
										{elevationId === undefined ||
										elevationId === ''
											? 'A'
											: elevationId}
									</div>
								</div>
							</div>
						</div>
						<div className='option_progress'>
							<div className={styles.progressBar}>
								<OptionProgress
									variant='determinate'
									value={normaliseTotalOptions(
										totalMainFloor
									)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										$
										{numberWithCommas(
											totalMainFloor &&
												totalMainFloor !== ''
												? totalMainFloor.toFixed(2)
												: 0
										)}
									</div>
									<div className='price_legend'>Options</div>
								</div>
							</div>
						</div>
						<div className='lot_progress'>
							<div className={styles.progressBar}>
								<LotProgress
									variant='determinate'
									value={normaliseLotPrice(lotPrice)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										${numberWithCommas(lotPrice.toFixed(2))}{' '}
										{premiumDescription}
									</div>
									<div className='price_legend'>
										Lot {pricingDetails[0]?.id}
									</div>
								</div>
							</div>
						</div>
						<div className='total_progress'>
							<div className={styles.progressBar}>
								<TotalProgress
									variant='determinate'
									value={normaliseTotalPrice(
										elevationPrice +
											lotPrice +
											totalMainFloor
									)}
								/>
								<div className='price_label'>
									<div className='price_amount'>
										{console.log(
											'gogot prix',
											numberWithCommas(
												(
													Number(elevationPrice) +
													Number(lotPrice) +
													Number(totalMainFloor)
												).toFixed(2)
											)
										)}
										$
										{elevationPrice !== undefined &&
											elevationPrice !== null &&
											numberWithCommas(
												(
													Number(elevationPrice) +
													Number(lotPrice) +
													Number(totalMainFloor)
												).toFixed(2)
											)}
									</div>
									<div className='price_legend'>Total</div>
								</div>
							</div>
						</div>
					</div>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					isCompleted.pricing === true && expanded !== 2
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='total_progress_final_display'>
					<div className={styles.progressBar}>
						<TotalProgress
							variant='determinate'
							value={normaliseTotalPrice(
								elevationPrice + lotPrice + totalMainFloor
							)}
						/>
						<div className='price_label'>
							<div className='price_amount'>
								$
								{numberWithCommas(
									(
										Number(elevationPrice) +
										Number(lotPrice) +
										Number(totalMainFloor)
									).toFixed(2)
								)}
							</div>
							<div className='price_legend'>Total</div>
						</div>
					</div>
				</div>
			</div>

			{/* Dates */}
			<Accordion
				square
				expanded={expanded === 3}
				onChange={handleChange(3)}
			>
				<AccordionSummary
					aria-controls='dates-content'
					id='dates-header'
					disabled={disable.dates}
				>
					<Typography
						className={styles.cardTitle}
						id={isCompleted.dates === true ? 'isCompleted' : null}
					>
						<StopRoundedIcon className={styles.caret} /> Dates
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleDatesNext();
							}}
							disabled={disable.dates}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{closingDate && (
							<div className='lot_single_card'>
								<p className='lot_single_title'>Closing Date</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
										{dayjs(closingDate).format(
											'DD MMMM YYYY'
										)}
									</span>
								</small>
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					isCompleted.dates === true && expanded !== 3
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='total_progress_final_display'>
					<div className='lot_modelhomes_container'>
						<div className='lot_single_card'>
							<p className='lot_single_title'>Closing Date</p>
							<small className='lot_single_sqft'>
								<span className='lot_availability'>
									<FiberManualRecordIcon className='available' />
									{dayjs(closingDate).format('DD MMMM YYYY')}
								</span>
							</small>
							<CheckIcon className='checkmark checkmark_active' />
						</div>
					</div>
				</div>
			</div>

			{/* Client */}
			<Accordion
				square
				expanded={expanded === 4}
				onChange={handleChange(4)}
			>
				<AccordionSummary
					aria-controls='client-content'
					id='client-header'
					disabled={disable.client}
				>
					<Typography
						className={styles.cardTitle}
						id={isCompleted.client === true ? 'isCompleted' : null}
					>
						{' '}
						<StopRoundedIcon className={styles.caret} />
						Client
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleClientNext();
							}}
							disabled={disable.client}
						>
							Next
						</button>
					</div>

					{individualDetails ? (
						<>
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{individualDetails?.firstName +
											' ' +
											individualDetails?.lastName}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										{individualDetails?.address}
									</small>
									<br />
									{console.log(
										JSON.stringify(corporationDetails)
									)}
									<small className='small_number'>
										{individualDetails?.phoneNumber}
									</small>
								</div>
							</div>
							{individualSecondPurchaserDetails?.firstName && (
								<div className='lot_modelhomes_container'>
									<div className='lot_single_card'>
										<p className='lot_single_title'>
											{individualSecondPurchaserDetails?.firstName +
												' ' +
												individualSecondPurchaserDetails?.lastName}
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{
												individualSecondPurchaserDetails?.address
											}
										</small>
										<br />
										{console.log(
											JSON.stringify(corporationDetails)
										)}
										<small className='small_number'>
											{
												individualSecondPurchaserDetails?.phoneNumber
											}
										</small>
									</div>
								</div>
							)}
						</>
					) : (
						corporationDetails && (
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{corporationDetails?.corporationName}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										{corporationDetails?.businessAddress}
									</small>
									<br />
									{console.log(
										JSON.stringify(corporationDetails)
									)}
									<small className='small_number'>
										{corporationDetails?.businessPhone}
									</small>
								</div>
							</div>
						)
					)}
				</AccordionDetails>
			</Accordion>

			<div
				className={
					isCompleted.client === true && expanded !== 4
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='total_progress_final_display'>
					{individualDetails ? (
						<>
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{individualDetails?.firstName +
											' ' +
											individualDetails?.lastName}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										{individualDetails?.address}
									</small>
									<br />
									<small className='small_number'>
										{individualDetails?.phoneNumber}
									</small>
								</div>
							</div>
							{individualSecondPurchaserDetails?.firstName && (
								<div className='lot_modelhomes_container'>
									<div className='lot_single_card'>
										<p className='lot_single_title'>
											{individualSecondPurchaserDetails?.firstName +
												' ' +
												individualSecondPurchaserDetails?.lastName}
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{
												individualSecondPurchaserDetails?.address
											}
										</small>
										<br />

										<small className='small_number'>
											{
												individualSecondPurchaserDetails?.phoneNumber
											}
										</small>
									</div>
								</div>
							)}
						</>
					) : (
						corporationDetails && (
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										{corporationDetails?.corporationName}
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
										</span>
										{corporationDetails?.businessAddress}
									</small>
									<br />

									<small className='small_number'>
										{corporationDetails?.businessPhone}
									</small>
									<CheckIcon className='checkmark checkmark_active' />
								</div>
							</div>
						)
					)}
				</div>
			</div>

			{/* Lawyer */}
			<Accordion
				square
				expanded={expanded === 5}
				onChange={handleChange(5)}
			>
				<AccordionSummary
					aria-controls='lawyer-content'
					id='lawyer-header'
					disabled={disable.lawyer}
				>
					<Typography
						className={styles.cardTitle}
						id={isCompleted.lawyer === true ? 'isCompleted' : null}
					>
						<StopRoundedIcon className={styles.caret} /> Lawyer
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleLawyerNext();
							}}
							disabled={disable.lawyer}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{lawyerDetails && (
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{lawyerDetails?.companyName}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									{lawyerDetails?.address}
								</small>
								<br />
								<small className='small_number'>
									{lawyerDetails?.phoneNumber}
								</small>
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					isCompleted.lawyer === true && expanded !== 5
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='total_progress_final_display'>
					<div className='lot_modelhomes_container'>
						{lawyerDetails && (
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{lawyerDetails?.companyName}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									{lawyerDetails?.address}
								</small>
								<br />
								<small className='small_number'>
									{lawyerDetails?.phoneNumber}
								</small>
								<CheckIcon className='checkmark checkmark_active' />
							</div>
						)}
					</div>
				</div>
			</div>

			{/* Co-Broker */}
			<Accordion
				square
				expanded={expanded === 6}
				onChange={handleChange(6)}
			>
				<AccordionSummary
					aria-controls='lawyer-content'
					id='lawyer-header'
					disabled={disable.coBroker}
				>
					<Typography
						className={styles.cardTitle}
						id={
							isCompleted.coBroker === true ? 'isCompleted' : null
						}
					>
						<StopRoundedIcon className={styles.caret} /> Co-Broker
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={() => {
								handleNext();
								handleCoBrokerNext();
							}}
							disabled={disable.coBroker}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{coBrokerDetails && (
							<div className='lot_single_card'>
								<p className='lot_single_title'>{`${coBrokerDetails?.salesAgency}`}</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									{coBrokerDetails?.agentName}
								</small>
								<br />
								<small className='small_number'>
									{coBrokerDetails?.phoneNumber}
								</small>
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>

			<div
				className={
					isCompleted.coBroker === true && expanded !== 6
						? 'final_display d-block'
						: 'd-none'
				}
			>
				<div className='total_progress_final_display'>
					<div className='lot_modelhomes_container'>
						{coBrokerDetails && (
							<div className='lot_single_card'>
								<p className='lot_single_title'>{`${coBrokerDetails?.salesAgency}`}</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									{coBrokerDetails?.agentName}
								</small>
								<br />
								<small className='small_number'>
									{coBrokerDetails?.phoneNumber}
								</small>
								<CheckIcon className='checkmark checkmark_active' />
							</div>
						)}
					</div>
				</div>
			</div>

			{/* Finances */}
			<Accordion
				square
				expanded={expanded === 7}
				onChange={handleChange(7)}
			>
				<AccordionSummary
					aria-controls='mortgage-content'
					id='mortgage-header'
					disabled={disable.finances}
				>
					<Typography
						className={styles.cardTitle}
						id={
							isCompleted.finances === true ? 'isCompleted' : null
						}
					>
						<StopRoundedIcon className={styles.caret} /> Finances
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className='nagivation_tab_btn'>
						<button className='back_btn' onClick={handleBack}>
							Back
						</button>
						<button
							className='next_btn'
							onClick={handleFinanceBtn}
							disabled={true}
						>
							Next
						</button>
					</div>
					<div className='lot_modelhomes_container'>
						{mortgageDetails?.totalDownpayment && (
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{mortgageDetails?.institutionName}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									TOTAL DOWNPAYMENT
									<span className='mortgage_amount_total'>
										${mortgageDetails?.totalDownpayment}
									</span>
								</small>
								<br />
							</div>
						)}
					</div>
					<button
						className='sign_doc'
						onClick={() => {
							handleFinanceBtn();
						}}
						disabled={disable.finances}
					>
						Review Document
					</button>
					{show && (
						<div
							onClick={closeModalHandler}
							className='back-drop'
						></div>
					)}
					<Modal
						show={show}
						close={closeModalHandler}
						title='Review Your Document'
						buttonName={
							userType !== 'cobroker'
								? 'Sign Document'
								: 'Send Document'
						}
						button={handleDocument}
					>
						{/* Model Homes, Pricing, Dates, Client, Lawyer, Finances */}
						<div className='lot_modelhomes_container'>
							<div className='lot_single_card'>
								<p className='lot_single_title'>
									{elevationList[0]?.buildingName}
								</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									Elevation{' '}
									{elevationId === undefined ||
									elevationId === ''
										? 'A'
										: elevationId}{' '}
									{'  '}/ {'  '}
									Lot {pricingDetails[0]?.id}
								</small>
								<div className='edit_btn'>
									<a
										onClick={() => {
											handleEdit();
											setExpanded(0);
											navigation.go(0);
										}}
									>
										Edit
									</a>
								</div>
							</div>
						</div>
						<div className='lot_modelhomes_container'>
							<div className='lot_single_card'>
								<p className='lot_single_title'>Total Cost</p>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='available' />
									</span>
									${numberWithCommas(totalCost)}
								</small>
								<div className='edit_btn'>
									<a
										onClick={() => {
											handleEdit();
											setExpanded(1);
											navigation.go(1);
										}}
									>
										Edit
									</a>
								</div>
							</div>
						</div>
						<div className='total_progress_final_display'>
							<div className='lot_modelhomes_container'>
								<div className='lot_single_card'>
									<p className='lot_single_title'>
										Closing Date
									</p>
									<small className='lot_single_sqft'>
										<span className='lot_availability'>
											<FiberManualRecordIcon className='available' />
											{dayjs(closingDate).format(
												'DD MMMM YYYY'
											)}
										</span>
									</small>
									<div className='edit_btn'>
										<a
											onClick={() => {
												handleEdit();
												setExpanded(3);
												navigation.go(3);
											}}
										>
											Edit
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className='total_progress_final_display'>
							{individualDetails ? (
								<div className='lot_modelhomes_container'>
									<div className='lot_single_card'>
										<p className='lot_single_title'>
											{individualDetails?.firstName}
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{individualDetails?.address}
										</small>
										<br />
										<small className='small_number'>
											{individualDetails?.phoneNumber}
										</small>
										<div className='edit_btn'>
											<a
												onClick={() => {
													handleEdit();
													setExpanded(4);
													navigation.go(4);
												}}
											>
												Edit
											</a>
										</div>
									</div>
								</div>
							) : (
								corporationDetails && (
									<div className='lot_modelhomes_container'>
										<div className='lot_single_card'>
											<p className='lot_single_title'>
												{
													corporationDetails?.corporationName
												}
											</p>
											<small className='lot_single_sqft'>
												<span className='lot_availability'>
													<FiberManualRecordIcon className='available' />
												</span>
												{
													corporationDetails?.businessAddress
												}
											</small>
											<br />
											<small className='small_number'>
												{
													corporationDetails?.businessPhone
												}
											</small>
											<div className='edit_btn'>
												<a
													onClick={() => {
														handleEdit();
														setExpanded(4);
														navigation.go(4);
													}}
												>
													Edit
												</a>
											</div>
										</div>
									</div>
								)
							)}
						</div>
						<div className='total_progress_final_display'>
							<div className='lot_modelhomes_container'>
								{lawyerDetails && (
									<div className='lot_single_card'>
										<small className='single_card_label'>
											Lawyer
										</small>
										<p className='lot_single_title'>
											{lawyerDetails?.companyName}
										</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{lawyerDetails?.address}
										</small>
										<br />
										<small className='small_number'>
											{lawyerDetails?.phoneNumber}
										</small>
										<div className='edit_btn'>
											<a
												onClick={() => {
													handleEdit();
													setExpanded(5);
													navigation.go(5);
												}}
											>
												Edit
											</a>
										</div>
									</div>
								)}
							</div>
						</div>
						<div className='total_progress_final_display'>
							<div className='lot_modelhomes_container'>
								{coBrokerDetails && (
									<div className='lot_single_card'>
										<small className='single_card_label'>
											Co-Broker
										</small>
										<p className='lot_single_title'>{`${coBrokerDetails?.salesAgency}`}</p>
										<small className='lot_single_sqft'>
											<span className='lot_availability'>
												<FiberManualRecordIcon className='available' />
											</span>
											{coBrokerDetails?.agentName}
										</small>
										<br />
										<small className='small_number'>
											{coBrokerDetails?.phoneNumber}
										</small>
										<div className='edit_btn'>
											<a
												onClick={() => {
													handleEdit();
													setExpanded(5);
													navigation.go(5);
												}}
											>
												Edit
											</a>
										</div>
									</div>
								)}
							</div>
						</div>
					</Modal>
				</AccordionDetails>
			</Accordion>
		</div>
	);
}

const mapStateToProps = (state) => ({
	user: state.signIn,
	userType: state.signIn.userType,
	coBrokersSalesAgent: state.clients.coBrokersSalesAgent,
});

export default connect(mapStateToProps)(StepBar);
